module.exports = __webpack_public_path__ + "static/media/c-low-fat.22cfeb00.jpg";